// Node
import i18next from 'i18next';
import i18CustomParams from 'new_design/common/i18_custom';
import { sortForMap, zIndexForMapMarker } from '../../../../filter_utils';

const $ = require('jquery');

import {
  addToFavorites,
  changeFavoriteBlock,
  changeMapMarker,
  changeUnfavoriteBlock,
  loadFavoriteCamps,
  removeFromFavorites,
} from '../../favorite';

// Custom
//require('./maps/camp_icon');
import axios from 'axios';
import window from 'inputmask/lib/global/window';
import MapGreyImage from 'map/grey.svg';

const MAX_FEWER_GUESTS_COUNT = 6; // aka maxFewerGuestsCount
const MAX_CAMPS_TO_SHOW_ON_SCREEN = 50;
const MAX_CAMPS_TO_SHOW_ON_SCREEN_MOBILE = 15;

const renderStaticMap = function () {
  const $map = $(this);
  const { camp, latitude, longitude, mapWidth, mapHeight } = $map.data();
  let mapParamsObj;

  if (latitude.length > 1 && longitude.length > 1) {
    let pl_arr = [];

    for (let i = 0; i < latitude.length; i++) {
      pl_arr.push(latitude[i]);
      pl_arr.push(longitude[i]);
    }
    // Если больше двух точек, замыкаем линию контура
    if (latitude.length > 2 && longitude.length > 2) {
      pl_arr.push(latitude[0]);
      pl_arr.push(longitude[0]);
    }

    pl_arr = pl_arr.join(',');

    mapParamsObj = {
      pl: `c:417ee1FF,w:3,${pl_arr}`, // параметр 'c' цвет линии, 'w' - толщина линии
      l: 'map',
      size: `${mapWidth},${mapHeight}`,
    };
  } else {
    mapParamsObj = {
      ll: `${longitude},${latitude}`,
      z: 12,
      l: 'map',
      size: `${mapWidth},${mapHeight}`,
      pt: `${longitude},${latitude},comma`,
    };
  }

  const mapParamsStr = Object.entries(mapParamsObj)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  $map.append(
    `<div style="background-image: url('https://static-maps.yandex.ru/1.x/?${mapParamsStr}');" class="camp_static_map"></div>`
  );
};

$(function () {
  window.camps = [];
  window.camps_markers = {};
  window.created_markers = {};
  window.created_markers.map_full = {};
  window.created_markers.map_to_area_center = {};
  window.created_markers.map_first_nearby_city = {};
  window.created_markers.map_second_nearby_city = {};
  let markersDataCache = {};
  window.distance = 0;
  window.favorite_camp_ids = [];

  const { date_start, date_end } = window.search_data || {};
  if (date_start && date_end) {
    window.loading_services = [...window.available_integrations, null];
  } else {
    window.loading_services = [null];
  }

  let mouseOnMarker = false;
  let mouseOnBalloon = false;
  let hoverTimeout = null;
  let rulerEditable = false;
  let ruler = null;
  let rulerButton = null;

  i18next.init(i18CustomParams(), function (err, t) {});

  /** Индикатор загрузки карты/объектов на карте */
  const loadingCircle = $('#loading-circle');
  /** Индикатор загрузки скрипта карты */
  const loadingOverlay = document.createElement('div');
  loadingOverlay.id = 'loading-overlay';
  loadingOverlay.className = 'loading-overlay';

  /** Выключить анимацию закгрузки карты/объектов на карте */
  const handleFinishLoadingAnimation = () => {
    if (!loadingCircle.hasClass('loader-circle-wrapper--hidden')) {
      loadingCircle.addClass('loader-circle-wrapper--hidden');
    }
  };

  /** Включить анимацию закгрузки карты/объектов на карте */
  const handleStartLoadingAnimation = () => {
    if (loadingCircle.hasClass('loader-circle-wrapper--hidden')) {
      loadingCircle.removeClass('loader-circle-wrapper--hidden');
    }
  };

  // Задать обработчики событий для действий с маркером
  // @param marker - объект маркера на карте
  // @param map - объект карты
  const initCampMarkerDesktopEvents = function (map) {
    const mapListener = new ymaps3.YMapListener({
      layer: 'any',
      onClick: (event) => {
        const entity = event?.entity;
        if (!entity) return;
        if (!(entity instanceof ymaps3.YMapMarker)) return;
        if (entity._url) {
          window.open(entity._url, '_blank');
        }
      },
      onMouseEnter: (event) => {
        const entity = event?.entity;
        if (!entity || !(entity instanceof ymaps3.YMapMarker)) return;

        const campId = entity._campId;
        const camp = window.camps.find((c) => c.id === campId) || (window.camp?.id === campId ? window.camp : null);
        if (!camp) return;

        const markerEl = entity.element;
        if (!markerEl) return;

        mouseOnMarker = true;

        let cachedData = markersDataCache[camp.id];
        if (cachedData) {
          setFavorite(camp.id, entity);
          openBalloon(entity, cachedData);
          setOrLoadBalloonPrice(camp, map, entity._map_name);
          initiateFavoriteClick(camp);
        } else {
          const { priceMin, priceMinWithoutDiscount, bonuses, discount } = getTariffData(camp);
          $.ajax({
            url: '/map-camp-balloon',
            data: {
              camp_id: camp.id,
              min_apartment_price: priceMin || 0,
              min_apartment_price_without_discount: priceMinWithoutDiscount || 0,
              discount: discount,
              is_can_instant_booking: camp.is_can_instant_booking,
              is_favorite: window.favorite_camp_ids.includes(camp.id),
              is_free_cancellation: camp.is_free_cancellation,
              food_name: camp.food_name,
              bonuses: bonuses,
              total_guests_count: camp.total_guests_count,
            },
            type: 'get',
            success: function (balloonData) {
              // Так как запрос асинхронный, дополнительная проверка, не подгрузились ли новые данные
              if (!cachedData) {
                markersDataCache[camp.id] = balloonData;
                setFavorite(camp.id, entity);
                openBalloon(entity, balloonData);
                initiateFavoriteClick(camp);
                setOrLoadBalloonPrice(camp, map, entity._map_name);
              }
            },
          });
        }
      },
      onMouseLeave: (event) => {
        const entity = event?.entity;
        if (!entity || !(entity instanceof ymaps3.YMapMarker)) return;

        mouseOnMarker = false;
        initiateCloseBalloon(entity);
      },
    });

    map.addChild(mapListener);
  };

  const toggleFavoriteCamp = function (campId, favoriteBlock, camp) {
    const isFavorite = window.favorite_camp_ids.includes(campId);

    if (isFavorite) {
      removeFromFavorites(campId, favoriteBlock);
      changeUnfavoriteBlock();
    } else {
      addToFavorites(campId, favoriteBlock);
      changeFavoriteBlock();
    }

    changeMapMarker(campId, isFavorite, camp.is_can_instant_booking);
  };

  const setBalloonPrice = function (camp, map, map_name) {
    let priceString = '';
    if (camp.min_apartment_price != null && camp.min_apartment_price !== -1) {
      priceString = `${Math.trunc(camp.min_apartment_price).toLocaleString('ru-RU')} ₽`;
    } else if (camp.can_request && window.website_type == 1) {
      priceString = 'Цена по запросу';
    } else if (!window.search_data.date_start) {
      priceString = '';
    } else {
      priceString = 'Мест нет';
    }
    $(`#balloon_price_${camp.id}`).html(priceString);
    const $balloonContent = $(markersDataCache[camp.id]);
    const $priceElement = $balloonContent.find(`#balloon_price_${camp.id}`);
    $priceElement.html(priceString);
    setBalloonGuestsCount(camp, $balloonContent);
    setBalloonBonuses(camp, $balloonContent);
    setRating(camp, $balloonContent);
    setRoomsCount(camp, $balloonContent);
    markersDataCache[camp.id] = $balloonContent.prop('outerHTML');
    const marker = window.created_markers[map_name][camp.id];
    if (marker?.element) {
      marker._iconEl.innerHTML = markerLayout(camp);
    }
  };

  const setRoomsCount = function (camp, $balloonContent) {
    console.log(camp);
    console.log(camp.apartments_categories_count);
    if (camp.apartments_categories_count?.length > 0) {
      const $roomsElement = $(`#balloon_count_rooms_${camp.id}`);
      $roomsElement.html(`${camp.apartments_categories_count}`);
      $roomsElement.show();
    }
  };

  const setBalloonGuestsCount = function (camp, $balloonContent) {
    let guestsString = '';
    const $guestsElement = $balloonContent.find(`#balloon_count_guests_${camp.id}`);
    if (camp.min_apartment_price != null && camp.min_apartment_price !== -1) {
      guestsString = camp.total_guests_count ? i18next.t('for_guest', { count: camp.total_guests_count }) : undefined;
    }
    $(`#balloon_count_guests_${camp.id}`).html(guestsString);
    $guestsElement.html(guestsString);
  };

  const setBalloonBonuses = function (camp, $balloonContent) {
    const $bonusesElement = $balloonContent.find(`#balloon_bonuses_${camp.id}`);
    const bonusesString = camp.bonuses ? i18next.t('bonus', { count: camp.bonuses }) : undefined;
    $(`#balloon_bonuses_${camp.id}`).html(bonusesString);
    $bonusesElement.html(bonusesString);
  };

  const setRating = function (camp, $balloonContent) {
    const $recommendedElement = $balloonContent.find(`#balloon_rating_${camp.id} .like`);
    if (camp.rating > 0) {
      $(`#balloon_rating_${camp.id} .card__rating-numb-big`).html(camp.rating);
      $balloonContent.find(`#balloon_rating_${camp.id} .card__rating-numb-big`).html(camp.rating);
      $(`#balloon_rating_${camp.id} .ratings-count`).html(camp.ratings_count_string);
      $balloonContent.find(`#balloon_rating_${camp.id} .ratings-count`).html(camp.ratings_count_string);
      if (camp.is_recommended) {
        $(`#balloon_rating_${camp.id} .like`).removeClass('like-without-rating');
        $recommendedElement.removeClass('like-without-rating');
      }
    } else {
      $(`#balloon_rating_${camp.id} .card__rating`).hide();
      $balloonContent.find(`#balloon_rating_${camp.id} .card__rating`).hide();
      $(`#balloon_rating_${camp.id} .ratings-count`).hide();
      $balloonContent.find(`#balloon_rating_${camp.id} .ratings-count`).hide();

      if (camp.is_recommended) {
        $(`#balloon_rating_${camp.id} .like`).addClass('like-without-rating');
        $recommendedElement.addClass('like-without-rating');
      }
    }
  };

  const setOrLoadBalloonPrice = function (camp, map, map_name) {
    if ((camp.min_apartment_price < 0 || !camp.min_apartment_price) && !camp.price_loaded) {
      fetch(`/camps/${camp.id}/min_apartment_price.json`)
        .then((res) => res.json())
        .then((data) => {
          camp.min_apartment_price = data.min_apartment_price;
          camp.can_request = data.can_request;
          camp.price_loaded = true;
          camp.total_guests_count = data.total_guests_count;
          camp.bonuses = data.bonuses;
          camp.rating = data.rating;
          camp.is_recommended = data.is_recommended;
          camp.ratings_count_string = data.ratings_count_string;
          camp.apartments_categories_count = data.apartments_categories_count;

          setBalloonPrice(camp, map, map_name);
        });
    }
  };

  const initCampMarkerMobileEvents = function (map, map_name) {
    const mapListener = new ymaps3.YMapListener({
      layer: 'any',
      onClick: (event) => {
        const entity = event?.entity;
        if (event?.type === 'hotspot' || !entity) {
          closeBalloon();
          if (window.openedBaloonCamp) {
            window.openedBaloonCamp = null;
            redrawMapMarkers(map, entity._map_name, true);
          }
        }
      },
      onActionEnd: async (event) => {
        closeBalloon();
        if (window.openedBaloonCamp) {
          window.openedBaloonCamp = null;
          redrawMapMarkers(map, map_name, true);
        }
      },
    });

    const markerListener = new ymaps3.YMapListener({
      layer: 'any',
      onClick: (event) => {
        const entity = event?.entity;
        if (!entity || event.type !== 'marker') return;

        const campId = entity._campId;
        const camp = window.camps.find((c) => c.id === campId) || (window.camp?.id === campId ? window.camp : null);
        if (!camp) return;

        let cachedData = markersDataCache[camp.id];
        window.openedBaloonCamp = camp;
        redrawMapMarkers(map, entity._map_name, true);
        if (cachedData) {
          $('#customInfoWindow').html(cachedData);
          setFavorite(camp.id, entity);
          initiateFavoriteClick(camp);
          $('#customInfoWindow').show();
          setOrLoadBalloonPrice(camp, map, entity._map_name);
        } else {
          const { priceMin, priceMinWithoutDiscount, bonuses, discount } = getTariffData(camp);
          $.ajax({
            url: '/map-camp-balloon',
            data: {
              camp_id: camp.id,
              min_apartment_price: priceMin || 0,
              min_apartment_price_without_discount: priceMinWithoutDiscount || 0,
              discount: discount,
              is_can_instant_booking: camp.is_can_instant_booking,
              is_favorite: window.favorite_camp_ids.includes(camp.id),
              is_free_cancellation: camp.is_free_cancellation,
              food_name: camp.food_name,
              bonuses: bonuses,
              total_guests_count: camp.total_guests_count,
            },
            type: 'get',
            success: function (balloonData) {
              // Так как запрос асинхронный, дополнительная проверка, не подгрузились ли новые данные
              if (!cachedData) {
                markersDataCache[camp.id] = balloonData;
                $('#customInfoWindow').html(balloonData);
                setFavorite(camp.id, entity);
                initiateFavoriteClick(camp);
                $('#customInfoWindow').show();
                setOrLoadBalloonPrice(camp, map, entity._map_name);
              }
            },
          });
        }
      },
    });

    map.addChild(mapListener);
    map.addChild(markerListener);
  };

  const setFavorite = function (campId, marker) {
    const $favoriteBlock = $(`.card_map__favorite-block[data-camp-id='${campId}']`);
    const $balloonContent = $(markersDataCache[campId]);
    const $balloonContentFavoriteBlock = $balloonContent.find(`.card_map__favorite-block[data-camp-id='${campId}']`);

    if ($favoriteBlock.length || $balloonContentFavoriteBlock.length) {
      if (window.favorite_camp_ids.includes(campId)) {
        $favoriteBlock.find('.favorite').addClass('unfavorite-icon').removeClass('favorite-icon');
        $balloonContentFavoriteBlock.find('.favorite').addClass('unfavorite-icon').removeClass('favorite-icon');
      } else {
        $favoriteBlock.find('.favorite').addClass('favorite-icon').removeClass('unfavorite-icon');
        $balloonContentFavoriteBlock.find('.favorite').addClass('favorite-icon').removeClass('unfavorite-icon');
      }

      markersDataCache[campId] = $balloonContent.prop('outerHTML');
    }
  };

  const markerIcon = function (camp, selected = false) {
    let iconClass = '';
    if (window.favorite_camp_ids.includes(camp.id)) {
      iconClass = selected ? 'unfavorite-icon selected' : 'unfavorite-icon';
    } else if (camp.is_can_instant_booking) {
      const baseClass = selected ? 'icon-flash_white' : 'icon-instant-fill';
      iconClass = `icon ${baseClass} ${baseClass}-dims`;
    }
    return `<div id="placemark-icon" class='${iconClass}'></div>`;
  };

  const discountIcon = function (discount, selected, camp) {
    if (!discount) return '';
    return `<div class='discount-icon ${selected ? 'selected' : ''}'></div>`;
  };

  const markerLayout = function (camp) {
    const { priceMin, discount } = getTariffData(camp);
    let classes = '';
    const campPrice = Math.trunc(priceMin);
    const selected = window.camp.id === camp.id || window.openedBaloonCamp?.id == camp.id;
    classes += selected ? ' selected' : '';
    classes += campPrice > 0 ? ' wide' : ' empty';
    const icon = markerIcon(camp, selected);

    return `<div class="placemark_layout_container ${classes}" data-camp-id="${camp.id}">
          ${icon}
          ${campPrice > 0 ? campPrice.toLocaleString('ru-RU') + ' ₽' : '•'}
          ${discountIcon(discount, selected, camp)}
        </div>`;
  };

  /**
   * Функция создания маркера ОР для карты.
   *
   * @param map карта
   * @param map_name название карты
   * @param camp ОР
   * @param {boolean} is_price_loaded загрузилась ли актуальная цена
   * @param options Дополнительные параметры
   * @param options.zIndex Расположение маркера по координате z.
   * @returns {ymaps3.YMapMarker|*}
   */
  const createCampMapMarker = function (map, map_name, camp, is_price_loaded, options) {
    if (window.created_markers[map_name][camp.id]) {
      return window.created_markers[map_name][camp.id];
    }
    let origin_camps = window.camps;
    let origin_camps_ids = new Set(window.camps.map((c) => parseInt(c.id)));

    if (!is_price_loaded) camp.min_apartment_price = -1;
    else if (camp.id == window.camp.id) window.camp.min_apartment_price = camp.min_apartment_price;
    else if (origin_camps_ids.has(parseInt(camp.id))) {
      let updated_camp = origin_camps.find((c) => c.id == camp.id);
      if (updated_camp) updated_camp.min_apartment_price = camp.min_apartment_price;
    }

    const { YMapMarker } = ymaps3;

    const el = document.createElement('div');
    el.className = 'marker-root';

    const icon = document.createElement('div');
    icon.className = 'marker-icon';

    const balloon = document.createElement('div');
    balloon.className = 'marker-balloon';

    el.appendChild(icon);

    const marker = new YMapMarker(
      {
        coordinates: [camp.longitude, camp.latitude],
        zIndex: options.zIndex,
      },
      el
    );

    marker._campId = camp.id;
    marker._url = camp.seo_path;
    marker._map_name = map_name;
    marker._camp = camp;
    marker._iconEl = icon;
    marker._balloonEl = balloon;

    marker._iconEl.innerHTML = markerLayout(camp);

    if (window.isMobileDevice) {
      window.camp.is_can_instant_booking = camp.is_can_instant_booking;
      initCampMarkerMobileEvents(map, map_name);
    } else if (!map._desktopListenerAdded) {
      window.camp.is_can_instant_booking = camp.is_can_instant_booking;
      initCampMarkerDesktopEvents(map);
      map._desktopListenerAdded = true;
    }

    // Удаляем старый маркер
    if (window.camps_markers[camp.id] != null) {
      map.removeChild(window.camps_markers[camp.id]);
      delete window.camps_markers[camp.id];
    }

    // Добавляем новый маркер
    map.addChild(marker);
    window.camps_markers[camp.id] = marker;
    window.created_markers[map_name][camp.id] = marker;

    return marker;
  };

  // Функция создания маркера города для карты.
  // @param map - карта
  // @param options - Дополнительные параметры
  //  @options option zIndex - Расположение маркера по координате z.
  const createCityMapMarker = function (map, map_name, city, options) {
    if (window.created_markers[map_name][city.id]) {
      return window.created_markers[map_name][city.id];
    }

    const { YMapMarker } = ymaps3;

    const el = document.createElement('div');
    el.innerHTML = `
      <img
        src="${MapGreyImage}"
        alt="${city.name}"
        style="
          width: 32px;
          height: 32px;
          transform: translate(-50%, -50%);
          pointer-events: auto;
        "
      />
    `;

    const marker = new YMapMarker(
      {
        coordinates: [city.location.longitude, city.location.latitude],
        zIndex: options.zIndex,
      },
      el
    );

    map.addChild(marker);

    window.created_markers[map_name][city.id] = marker;

    return marker;
  };

  const redrawMapMarkers = async function (map, map_name, redrawAll = false) {
    if (!map?.bounds) return [];
    const [[minLng, maxLat], [maxLng, minLat]] = map.bounds;

    let camps_to_show = window.camps.filter((camp) => {
      return camp.longitude >= minLng && camp.longitude <= maxLng && camp.latitude >= minLat && camp.latitude <= maxLat;
    });

    camps_to_show = sortForMap(camps_to_show, window.camp.id);
    camps_to_show = camps_to_show.slice(
      0,
      window.isMobileDevice ? MAX_CAMPS_TO_SHOW_ON_SCREEN_MOBILE : MAX_CAMPS_TO_SHOW_ON_SCREEN
    );
    camps_to_show.push(window.camp);

    const camps_to_show_ids = camps_to_show.map((camp) => camp.id);
    const created_ids = Object.keys(window.created_markers[map_name]);
    let markers_to_delete;
    if (redrawAll) {
      markers_to_delete = created_ids;
    } else {
      markers_to_delete = created_ids.filter((id) => !camps_to_show_ids.includes(parseInt(id)));
    }
    markers_to_delete.forEach(function (id) {
      map.removeChild(window.created_markers[map_name][id]);
      delete window.created_markers[map_name][id];
    });

    camps_to_show.forEach(function (camp) {
      createCampMapMarker(map, map_name, camp, true, {
        zIndex: zIndexForMapMarker(camp, window.camp.id, window.openedBaloonCamp?.id == camp.id),
      });
    });
  };

  const addNewCampMapMarkers = function (map, map_name, camps) {
    if (!map) return;

    const old_camps_ids = window.camps.map((camp) => camp.id);

    // Перезаписываем только ОР у которых лучше предложение - моменталка, или меньше цена
    let new_camps = camps.filter((new_camp) => {
      if (old_camps_ids.indexOf(new_camp.id) === -1) return true;

      const old_camp = window.camps.find((camp) => camp.id == new_camp.id);
      if (!old_camp.is_can_instant_booking && new_camp.is_can_instant_booking) return true;

      return (
        (old_camp.is_can_instant_booking === new_camp.is_can_instant_booking &&
          old_camp.min_apartment_price > new_camp.min_apartment_price) ||
        !old_camp.min_apartment_price
      );
    });

    // Убираем из старых ОР, те, которые заменяем
    const new_camps_ids = new Set(new_camps.map((camp) => parseInt(camp.id)));
    const old_camps = window.camps.filter((camp) => !new_camps_ids.has(parseInt(camp.id)));

    window.camps = [...new_camps, ...old_camps];

    new_camps.forEach((camp) => {
      // Обновляем кэш для текущего кэмпа, так как получаем актуальные цены
      markersDataCache[camp.id] = undefined;
    });
    redrawMapMarkers(map, map_name, true);
  };

  /**
   * Создает карту
   *
   * @param map_name
   * @param first_opening
   * @returns {Promise<*>} Карта
   */
  const createMap = async function (map_name, first_opening = true) {
    if (typeof ymaps3 == 'undefined') {
      handleStartLoadingAnimation();
      document.body.appendChild(loadingOverlay);
      let script = document.createElement('script');
      let promise = new Promise((resolve, reject) => {
        script.onload = () => {
          ymaps3.ready.then(() => {
            resolve();
          });
        };
        script.src = $('#ymaps-lazy-script').data('src');
        document.getElementsByTagName('head')[0].appendChild(script);
      });
      await promise;
    }

    await ymaps3.ready;

    if (!ymaps3._defaultUiThemeRegistered) {
      ymaps3.import.registerCdn('https://cdn.jsdelivr.net/npm/{package}', ['@yandex/ymaps3-default-ui-theme@0.0.24']);
      ymaps3._defaultUiThemeRegistered = true;
    }

    const { YMapZoomControl } = await ymaps3.import('@yandex/ymaps3-default-ui-theme');

    const { YMapDefaultRuler } = await ymaps3.import('@yandex/ymaps3-default-ui-theme');

    // Creating a nested layout for balloon content.
    window.CampBalloonContentLayout = markersDataCache[camp.id];

    const { YMapDefaultSchemeLayer, YMapDefaultFeaturesLayer } = ymaps3;

    window[map_name] =
      window[map_name] ||
      new ymaps3.YMap(document.getElementById('map'), {
        location: {
          center: [window.camp.longitude, window.camp.latitude],
          zoom: 13,
        },
      })
        .addChild(new YMapDefaultSchemeLayer())
        .addChild(new YMapDefaultFeaturesLayer());

    window.favorite_camp_ids = await loadFavoriteCamps();

    if (first_opening)
      createCampMapMarker(window[map_name], map_name, window.camp, true, {
        zIndex: zIndexForMapMarker(window.camp, window.camp.id, true),
      });

    window[map_name].update({
      center: [window.camp.longitude, window.camp.latitude],
    });

    const controls = new ymaps3.YMapControls({
      position: 'top right',
      orientation: 'horizontal',
    });

    const fullscreenButton = new ymaps3.YMapControlButton({
      text: 'Закрыть карту',
      onClick: () => {
        handleCloseMap();
      },
    });

    rulerButton = new ymaps3.YMapControlButton({
      text: 'Линейка',
      onClick: () => toggleRuler(),
    });

    if (!window.isMobileDevice) {
      controls.addChild(rulerButton);
      controls.addChild(fullscreenButton);
      window[map_name].addChild(controls);
    }

    const zoomControls = new ymaps3.YMapControls({
      position: 'right',
      orientation: 'vertical',
    });

    zoomControls.addChild(new YMapZoomControl());
    window[map_name].addChild(zoomControls);

    ruler = new YMapDefaultRuler({
      type: 'ruler',
      editable: rulerEditable,
      points: [],
    });

    window[map_name].addChild(ruler);

    localizeRulerControls();

    const mapListener = new ymaps3.YMapListener({
      layer: 'any',
      onActionEnd: async () => {
        redrawMapMarkers(window[map_name], 'map_full');
        if (window.loadCampsMapTimeout) {
          clearTimeout(window.loadCampsMapTimeout);
        }
        window.loadCampsMapTimeout = setTimeout(() => {
          loadCamps(window[map_name]);
        }, 1000);
      },
    });

    window[map_name].addChild(mapListener);

    $('#map_close_btn').click(() => {
      handleCloseMap();
    });

    return window[map_name];
  };

  // Обработчик нажатия на кнопку отображения карты
  $('.huge_map_open').on('click', async (event) => {
    const popup_id = 'camp_huge_map';
    if (
      window.openedPopupsIdsStack.length === 0 ||
      window.openedPopupsIdsStack[window.openedPopupsIdsStack.length - 1] !== '#' + popup_id
    ) {
      history.pushState(
        { hash: popup_id },
        document.title,
        window.location.pathname + window.location.search + '#' + popup_id
      );
      window.openedPopupsIdsStack.push('#' + popup_id);
    }
    $('.filter_map-top').css({ display: 'flex' });
    $('#map').removeClass('hidden').show();
    $('.camp-tabs__placeholder').hide();
    const map = await createMap('map_full', window.camps.length === 0);
    requestAnimationFrame(() => {
      map.update({
        location: {
          center: [window.camp.longitude, window.camp.latitude],
          zoom: 13,
        },
      });
    });

    const { date_start, date_end, count_guests } = window.search_data || 0;
    if (window.date_start !== date_start || window.date_end !== date_end || count_guests !== window.count_guests) {
      window.camps = [];
    }

    if (window.camps.length === 0) {
      // Получение списка ОР для карты
      loadAllCamps(map);
    } else {
      redrawMapMarkers(map, 'map_full');
    }
  });

  const handleCloseMap = () => {
    loadingOverlay?.remove();
    handleFinishLoadingAnimation();

    gtag('event', `${window.isMobileDevice ? 'm' : 'd'}.close_on_object`, {
      event_category: 'Map',
      event_label: `${window.camp.region_name}, ${window.camp.name}, ${window.mapOpenedFrom}`,
    });

    if (
      window.openedPopupsIdsStack.length > 0 &&
      window.location.hash === '#camp_huge_map' &&
      window.openedPopupsIdsStack[window.openedPopupsIdsStack.length - 1] === '#camp_huge_map'
    ) {
      window.openedPopupsIdsStack.pop();
      history.back();
    }
    $('.filter_map-top').hide();
    $('#customInfoWindow').hide();
    $('#map').hide();
    $('.camp-tabs__placeholder').show();
  };

  /**
   * Функция параллельной загрузки ОР'ов
   */
  const loadAllCamps = function (map) {
    handleStartLoadingAnimation();

    loadCamps(map);
  };

  /**
   * Згразка ОР'ов от CM/собственных
   *
   * @param map
   */
  const loadCamps = function (map) {
    if (!map || !map.bounds) return;
    const [[minLng, minLat], [maxLng, maxLat]] = map.bounds;

    handleStartLoadingAnimation();

    let request_data = {};
    request_data.region_id = window.globalRegionId;
    request_data.city_id = window.camp?.city_id;
    request_data.country_id = window.camp?.country_id;

    window.count_guests = window.search_data?.count_guests;
    window.date_start = window.search_data?.date_start;
    window.date_end = window.search_data?.date_end;

    request_data.date_start = window.search_data?.date_start;
    request_data.date_end = window.search_data?.date_end;
    request_data.count_guests = window.search_data?.count_guests;
    request_data.children_ages = window.search_data?.children_ages;
    request_data.without_cookies = true;
    request_data.exclude_ids = window.camps.map((c) => c.id).join(',');
    request_data.min_lng = minLng;
    request_data.max_lng = maxLng;
    request_data.min_lat = minLat;
    request_data.max_lat = maxLat;

    if (window.search_data?.date_start) {
      axios.post('/map_camps.json', { ...request_data, load_integrations: false }).then((res) => {
        addNewCampMapMarkers(map, 'map_full', res.data.camps);
        request_data.exclude_ids = [...request_data.exclude_ids, ...res.data.camps.map((c) => c.id)];
        axios
          .post('/map_camps.json', { ...request_data, load_mt: false })
          .then((res) => {
            addNewCampMapMarkers(map, 'map_full', res.data.camps);
          })
          .finally(handleCampsLoaded);
      });
    } else {
      axios.post('/map_camps.json', { ...request_data }).then((res) => {
        addNewCampMapMarkers(map, 'map_full', res.data.camps);
      }).finally(handleCampsLoaded);
    }
  };

  const handleCampsLoaded = function () {
    handleFinishLoadingAnimation();
  };

  // Обработчик нажатия на кнопку отображения карты с путем от ОР до города
  $('.camp_to_area_center_distance').on('click', async (event) => {
    const map = await createMap('map_to_area_center');
    createCityMapMarker(map, 'map_to_area_center', area_center, {
      zIndex: 201,
    });
    // createDirection(map, window.area_center.location, window.camp, city_type: 'area_center')
  });

  $('.first_nearby_city').on('click', async (event) => {
    const map = await createMap('map_first_nearby_city');
    createCityMapMarker(map, 'map_first_nearby_city', first_nearby_city, {
      zIndex: 201,
    });
    // createDirection(map, window.first_nearby_city.location, window.camp, city_type: 'first_nearby_city')
  });

  $('.second_nearby_city').on('click', async (event) => {
    const map = await createMap('map_second_nearby_city');
    createCityMapMarker(map, 'map_second_nearby_city', second_nearby_city, {
      zIndex: 201,
    });
    // createDirection(map, window.first_nearby_city.location, window.camp, city_type: 'second_nearby_city')
  });

  $('.card__close_btn').on('click', () => {
    $('#customInfoWindow').hide();
  });

  $('#small_map, #map_side').each(renderStaticMap);

  const initiateCloseBalloon = function (marker) {
    clearTimeout(hoverTimeout);

    if (!mouseOnMarker) {
      closeBalloon(marker);
    }
  };

  const initiateFavoriteClick = function (camp) {
    $('.card_map__favorite-block').on('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      const campId = $(this).data('camp-id');
      toggleFavoriteCamp(campId, $(this), camp);
    });
  };

  const openBalloon = (marker, html) => {
    renderBalloon(marker, html);
    marker.update({ zIndex: zIndexForMapMarker(marker._camp, window.camp.id, true) });
    marker.element.parentNode.classList.add('show-balloon');

    for (let m of Object.values(window.created_markers[marker._map_name] || {})) {
      if (m !== marker) {
        m.element.parentNode.classList.remove('show-balloon');
        m.update({ zIndex: zIndexForMapMarker(m._camp, window.camp.id) });
      }
    }
  };

  const closeBalloon = (marker = null) => {
    $('#customInfoWindow').hide();
    if (marker) {
      marker.update({ zIndex: zIndexForMapMarker(marker._camp, window.camp.id) });
      marker.element.parentNode.classList.remove('show-balloon');
    }
  };

  const renderBalloon = (marker, html) => {
    if (!marker._balloonEl.parentNode) {
      marker.element.after(marker._balloonEl);
    }

    marker._balloonEl.innerHTML = html;
  };
  const toggleRuler = () => {
    rulerEditable = !rulerEditable;

    if (ruler) {
      ruler.update({
        editable: rulerEditable,
        points: [],
      });
    }

    if (rulerButton) {
      rulerButton.update({
        color: rulerEditable ? '#196dff' : '#222222',
      });
    }
  };

  const localizeRulerControls = () => {
    if (window.rulerObserver) return;

    const replaceTitles = () => {
      $('.ymaps3--default-ruler-point_actions button').each((_, btn) => {
        const $btn = $(btn);

        if ($btn.attr('title') === 'Remove all points') {
          $btn.attr('title', 'Удалить точки');
        }

        if ($btn.attr('title') === 'Finish editing the ruler') {
          $btn.attr('title', 'Завершить редактирование');
        }
      });
    };

    replaceTitles();

    window.rulerObserver = new MutationObserver(() => {
      replaceTitles();
    });

    window.rulerObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  const getTariffData = (camp) => {
    let bonuses, tariff, allGuestCount, discount;

    const apartments = camp.apartments;
    const complexPlacement = camp.complex_placement;

    if (complexPlacement) {
      bonuses = complexPlacement.total_bonuses;
      tariff = complexPlacement.items?.[0]?.tariff;
      allGuestCount = complexPlacement.total_guests;
    } else if (apartments) {
      bonuses = apartments[0]?.bonuses;
      tariff = apartments[0]?.tariffs[0];
      allGuestCount = (tariff?.seats ?? 0) + (tariff?.seats_additional ?? 0) + (tariff?.child_count_no_seats ?? 0);
      discount = tariff?.discount;
    }

    const priceMin = tariff?.calculated_price ?? null;
    const priceMinWithoutDiscount = tariff?.calculated_price_without_discount ?? null;

    return {
      tariff,
      bonuses: bonuses ?? 0,
      priceMin,
      priceMinWithoutDiscount,
      allGuestCount,
      discount: discount ?? 0,
    };
  };
});

export { renderStaticMap };
